import { en } from "./translations.en";
import { fr } from "./translations.fr";
import { pt } from "./translations.pt";

export const translations = {
  en: {
    common: en,
  },
  fr: {
    common: fr,
  },
  pt: {
    common: pt,
  },
};
